module.exports = __webpack_public_path__ + "img/assistLogo.b22fdaf5.png";